import useSWR from "swr";
import { URL_API } from "../../../@richbeauty/services/endpoint";
import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";

const getAllUsers = async () => {
  const { data } = await jwtAxios.get(URL_API.CMS_USERS.GET_USERS, {
    params: {
      page: 1,
      take: 1000,
    },
  });
  return data;
};
const useGetAllUsers = () => {
  const fetcher = () => getAllUsers();
  return useSWR(
    {
      url: URL_API.CMS_USERS.GET_ALL_USERS,
      tags: ["#users"],
    },
    fetcher
  );
};

export default useGetAllUsers;
